import React, { useState } from 'react';

import {
	Alert, Button,
	Table, Form, Input,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'

const defaultTemplate = {
	id: 0,
	title  : "",
	subject: "[company_name] | [job_name]",
	body   : "Hi,\n\nPlease fill out the form located at the link below:\n\n[job_name]\n[link address]\n\nThanks,\n[user_name]\n[user_email]"
}

const EmailTemplates = ({ templates, saveEmailTemplate, removeEmailTemplate }) => {

	/* ************************************************************************ */
	/* ***** Email Template Functions *********************************** ***** */
	/* ************************************************************************ */
	const [ emailTemplateModal, setEmailTemplateModal ] = useState(false);
	const [ editTemplate, setEditTemplate ] = useState(defaultTemplate);

	const [ copiedField, setCopiedField ] = useState(null);
	const [ isSaving, setIsSaving ] = useState(false);

	const toggleEmailTemplateModal = () => {
		setEmailTemplateModal(!emailTemplateModal);
	}

	const addNewEmailTemplate = () => {
		setEditTemplate(defaultTemplate);
		setEmailTemplateModal(true);
	}

	const editEmailTemplate = (template) => {
		console.log('editEmailTemplate', template);

		setEmailTemplateModal(true);
		setEditTemplate(template);
	}

	const saveEmailTemplateData = () => {
		saveEmailTemplate(editTemplate);
		setEmailTemplateModal(false);
		setIsSaving(false);
	}

	const handleChange = e => {
		const { name, value } = e.target;
		setEditTemplate({
			...editTemplate,
			[name]: value
		});
	}

	const copyToClipboard = (text) => {
		navigator.clipboard.writeText(text);
		setCopiedField(text);
		setTimeout(() => {
			setCopiedField(null);
		}, 2000);
	}

	const mergeFields = [ 
		{ value: '[link_address]', title: 'dynamically-created link to this job' },
		{ value: '[job_number]', title: 'Job Number' },  // Customer Reference Number
		{ value: '[customer_name]', title: 'Customer Name' },
		{ value: '[job_name]', title: 'Job Name' },
		{ value: '[company_name]', title: 'Company Name' },
		{ value: '[user_name]', title: 'User Name (Your Name)' },
		{ value: '[user_email]', title: 'User Email (Your Email)' }
	];

	const { id, title, subject, body } = editTemplate;

	return (
		<>
			<Modal isOpen={emailTemplateModal} toggle={toggleEmailTemplateModal} style={{ 'maxWidth': '1024px' }}>
				<ModalHeader toggle={toggleEmailTemplateModal}>
					<span>{id ? 'Edit Email Template' : 'Add New Email Template'}</span>
				</ModalHeader>
				<ModalBody>
					<div className="form-group">
						<label htmlFor="title">Title</label>
						<Input type="text" name="title" placeholder="Title" value={title} onChange={handleChange} />
					</div>
					<div className="form-group">
						<label htmlFor="subject">Subject</label>
						<Input type="text" name="subject" placeholder="Subject" value={subject} onChange={handleChange} />

					</div>
					<div className="d-flex">
						<div className="form-group w-75">
							<label htmlFor="body">Body</label>
							<textarea name="body" className="form-control" rows="10" value={body} onChange={handleChange}></textarea>
						</div>
						<div className="w-25 p-3">
							<cite style={{ fontSize: '.9rem' }}>
								<h6 title="The following merge fields can be included in the Subject and/or Body">Merge Fields</h6>
								<ul className="list-unstyled">
									{mergeFields.map((mf, idx) => (
										<li key={idx} className="cursor-pointer merge-field-item" onClick={() => copyToClipboard(mf.value)}>
											<span title={mf.title}>{mf.value}</span>{' '}
											{copiedField === mf.value ? (
												<><i className="fas fa-check ml-1"></i> <span className="small">copied</span></>
											) : (
												<i className="far fa-copy ml-1 hover-icon"></i>
											)}
										</li>
									))}
								</ul>
							</cite>
						</div>
					</div>
				</ModalBody>
				<ModalFooter className="justify-content-between">
					<Button type="button" color="danger" onClick={toggleEmailTemplateModal}>Cancel</Button>
					<Button color={isSaving || (!title || !subject || !body) ? "secondary" : "primary"} className="ml-3" onClick={saveEmailTemplateData} disabled={isSaving || (!title || !subject || !body)}>Save</Button>
				</ModalFooter>
			</Modal>

			<h4>
				Email Templates
				<Button size="sm" color="primary" className="ml-3" onClick={addNewEmailTemplate}>Add New</Button>
			</h4>
		
			{templates.length > 0 && (
				<div className="input-group">
					<Table responsive className="mt-3">
						<thead>
							<tr>
								<th>&nbsp;</th>
								<th>Title</th>
								<th>Subject</th>
								<th>Body</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							{templates.map((template, index) => {
								return (<tr key={index}>
									<td>{index + 1}</td>
									<td>{template.title}</td>
									<td>{template.subject}</td>
									<td>{template.body}</td>
									<td className="d-flex">
										<Button size="sm" color="secondary" data-template-id={template.id} onClick={() => editEmailTemplate(template)}>Edit</Button>
										<Button size="sm" color="danger" data-template-id={template.id} className="ml-3" onClick={() => removeEmailTemplate(template)}>Delete</Button>
									</td>
								</tr>)
							})}
						</tbody>
					</Table>
				</div>
			)}
		</>
	)
}

export default EmailTemplates;